interface IClientColors {
    bgPrimary: string;
    bgSecondary: string;
    borderPrimary: string;
    borderSecondary: string;
    hoverPrimary: string;
    hoverQuaternary: string;
    hoverSecondary: string;
    hoverTertiary: string;
    primary: string;
    secondary: string;
    surfaceCard: string;
    surfaceDefault: string;
    surfaceGlass: string;
    text: string;
}

interface IClientTheme {
    colors: IClientColors;
    hiddenProductNames?: string[];
    logoUrl: string;
    name: string;
    slug: string;
}

const DEFAULT_COLORS: IClientColors = {
    primary: '#2CAFA5',
    bgPrimary: '#2CAFA5',
    bgSecondary: '#FFFFFF',
    borderPrimary: '#8BD3CE',
    borderSecondary: '#5AC1B9',
    hoverPrimary: '#4CBBB2',
    hoverSecondary: '#F9FAFB',
    hoverTertiary: '#6BC7C0',
    hoverQuaternary: '#F3F4F6',
    secondary: '#8BD3CE',
    surfaceGlass: '#CAEBE8',
    surfaceCard: '#FFFFFF',
    surfaceDefault: '#FAFAFA',
    text: '#2CAFA5',
};

const CLIENT_REGISTRY: IClientTheme[] = [
    {
        slug: 'default',
        name: 'GOBELETCUP®',
        logoUrl: '/clients/gobeletcup/configurator-logo.svg',
        hiddenProductNames: ['faire_part'],
        colors: DEFAULT_COLORS,
    },
    {
        slug: 'cupkiller',
        name: 'CupKiller',
        logoUrl: '/clients/cupkiller/logo.svg',
        colors: {
            ...DEFAULT_COLORS,
            primary: '#22434c',
            bgPrimary: '#22434c',
            bgSecondary: '#e8f0f2',
            borderPrimary: '#8ab5bf',
            borderSecondary: '#4d8090',
            hoverPrimary: '#2d5565',
            hoverSecondary: '#e8f0f2',
            hoverTertiary: '#5a9aaa',
            hoverQuaternary: '#d0e8ed',
            secondary: '#8ab5bf',
            surfaceGlass: '#c5dfe4',
            surfaceCard: '#e8f0f2',
            surfaceDefault: '#f0f6f8',
            text: '#22434c',
        },
    },
    {
        slug: 'gobeletcup',
        name: 'GOBELETCUP®',
        logoUrl: '/clients/gobeletcup/configurator-logo.svg',
        hiddenProductNames: ['faire_part'],
        colors: DEFAULT_COLORS,
    },
    // Ajouter les clients ici :
    // {
    //     slug: 'mon-client',
    //     name: 'Mon Client',
    //     logoUrl: '/clients/mon-client/logo.svg',
    //     colors: {
    //         ...DEFAULT_COLORS,
    //         primary: '#E84444',
    //         bgPrimary: '#E84444',
    //         text: '#E84444',
    //         hoverPrimary: '#C93333',
    //         // ...
    //     },
    // },
];

function getClientBySlug(slug: string): IClientTheme {
    return CLIENT_REGISTRY.find((c) => c.slug === slug) ?? CLIENT_REGISTRY[0];
}

function isKnownClientSlug(slug: string): boolean {
    return CLIENT_REGISTRY.some((c) => c.slug === slug);
}

export { getClientBySlug, isKnownClientSlug };

export type { IClientColors, IClientTheme };
